import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

import DriverRequestDetails from "@/components/Driver/DriverRequestDetails";
import { ConfirmationDialogButton } from "@/components/Driver/DriverRequestDetails/confirmation-dialog-button";
import { useDisableDriverMutation, useGetDriverByIdQuery } from "@/libs/generated/hooks";
import {
  DRIVER_ACTIONS,
  ERROR_MESSAGES,
  NAVIGATION_ROUTES,
  SUCCESS_MESSAGES,
  TOAST_CONFIG,
} from "@/utils/constants/driver-actions";

function AcceptedDriverDetails() {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  if (!id) throw new Error("no driver id in params");
  const {
    data,
    error,
    isPending: loading,
  } = useGetDriverByIdQuery({
    GetByIdInput: {
      id: Number(id),
    },
  });

  const disableDriver = useDisableDriverMutation({
    onSuccess: () => {
      toast.success(t(SUCCESS_MESSAGES.DISABLE), TOAST_CONFIG);
      navigate(NAVIGATION_ROUTES.GO_BACK);
    },
    onError: (err: any) => {
      toast.error(err.message || t(ERROR_MESSAGES.GENERIC), TOAST_CONFIG);
    },
  });

  const isDisablingDriver = disableDriver.isPending;

  if (loading) return <p>{t("common.loading")}</p>;

  if (error) {
    return <p>{t("common.error.generic")}</p>;
  }
  if (!data?.getDriverById) {
    return <p>{t("common.no-data")}</p>;
  }
  const driverData = data.getDriverById;
  return (
    <DriverRequestDetails
      driverData={driverData}
      showTerms={true}
      actions={
        <ConfirmationDialogButton
          buttonText={DRIVER_ACTIONS.DISABLE.buttonText}
          title={DRIVER_ACTIONS.DISABLE.title}
          icon={DRIVER_ACTIONS.DISABLE.icon}
          buttonColor={theme.palette.error.main}
          description={DRIVER_ACTIONS.DISABLE.confirmation}
          actionIsLoading={isDisablingDriver}
          onConfirm={() => {
            disableDriver.mutate({
              input: {
                email: driverData.email,
              },
            });
          }}
        />
      }
    />
  );
}

export default AcceptedDriverDetails;
